import React, { useEffect, useRef } from 'react';
import { useIntl } from 'react-intl';

import MagicWandFrap from 'shared/app/components/magic-wand-frap';
import { usePdpContext } from 'ordering/app/components/product-details-page/pdp-provider';
import ResetRecipeButton from '../reset-recipe-button';
import messages from './messages';

const CallsToAction = ({ filteredSelectedOptions }) => {
  const { formatMessage } = useIntl();
  const customizeButtonRef = useRef(null);
  const { doneCustomizing, product, setIsCustomizing } = usePdpContext();
  const { productOptions } = product ?? {};

  useEffect(() => {
    if (doneCustomizing) {
      // user previously clicked the customize button to go into
      // the customizations pane, and that is where focus should
      // return when they have clicked "done customizing"
      customizeButtonRef.current?.focus();
    }
  }, [doneCustomizing]);

  const clickHandler = () => {
    setIsCustomizing(true);
  };

  return (
    <React.Fragment>
      {productOptions?.length ? (
        <div className="pt5 text-center md-text-left">
          <MagicWandFrap
            message={formatMessage(messages.customizeLabel)}
            onClick={clickHandler}
            ref={customizeButtonRef}
          />
        </div>
      ) : null}
      {filteredSelectedOptions?.length ? (
        <div className="pt6 text-center md-text-left">
          <ResetRecipeButton onResetRecipeRef={customizeButtonRef} />
        </div>
      ) : null}
    </React.Fragment>
  );
};

export default CallsToAction;
